import React from 'react';
import { TrophyIcon, UsersIcon, MapPinIcon, StarIcon, AwardIcon, BriefcaseIcon, ArrowRightIcon } from 'lucide-react';
export function SocialProof() {
  const achievements = [{
    icon: TrophyIcon,
    value: 'Top Performer',
    label: 'Academia Josué Peña'
  }, {
    icon: UsersIcon,
    value: 'Mentor Activo',
    label: 'Guiando nuevos closers'
  }, {
    icon: MapPinIcon,
    value: '100% Remoto',
    label: 'Libertad total'
  }];
  const testimonials = [{
    text: 'Su enfoque práctico me ayudó a entender el proceso real del closing sin complicaciones.',
    name: 'Carlos M.'
  }, {
    text: 'Aprendí más en sus sesiones de mentoría que en meses consumiendo contenido por mi cuenta.',
    name: 'María S.'
  }, {
    text: 'Su historia como padre inmigrante me inspiró a dar el primer paso que tanto postergaba.',
    name: 'Luis R.'
  }];
  const handleCTAClick = () => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'Lead');
    }
  };
  return <section className="w-full px-4 py-16 md:py-24 bg-dark" data-id="element-243">
      <div className="max-w-6xl mx-auto" data-id="element-244">
        <div className="text-center mb-12" data-id="element-245">
          <h2 className="text-[28px] md:text-[40px] lg:text-[56px] font-bold font-poppins text-white mb-5 tracking-tight uppercase" data-id="element-246">
            Experiencia Real, Resultados Reales
          </h2>
          <p className="text-[18px] md:text-[22px] font-inter text-textGray max-w-[30ch] mx-auto leading-relaxed" data-id="element-247">
            No soy un influencer. Soy alguien que dominó esta habilidad y ahora
            la comparte.
          </p>
        </div>
        <div className="mb-12" data-id="element-248">
          <div className="grid md:grid-cols-3 gap-6 mb-10" data-id="element-249">
            {achievements.map((achievement, index) => {
            const Icon = achievement.icon;
            return <div key={index} className="bg-lightBg p-8 rounded-2xl border-4 border-primary text-center transform hover:scale-105 transition-all duration-300 shadow-2xl" data-id="element-250">
                  <Icon className="w-12 h-12 text-primary mx-auto mb-4" data-id="element-251" />
                  <p className="text-[24px] md:text-[28px] font-bold font-poppins text-textDark mb-2 uppercase" data-id="element-252">
                    {achievement.value}
                  </p>
                  <p className="text-[15px] md:text-[17px] font-inter text-textDark" data-id="element-253">
                    {achievement.label}
                  </p>
                </div>;
          })}
          </div>
          <div className="bg-lightBg p-8 md:p-12 rounded-3xl border-4 border-primary shadow-2xl" data-id="element-254">
            <div className="flex items-center justify-center gap-3 mb-6" data-id="element-255">
              <AwardIcon className="w-8 h-8 md:w-10 md:h-10 text-primary" data-id="element-256" />
              <p className="text-[26px] md:text-[36px] font-bold font-poppins text-center text-primary tracking-tight uppercase" data-id="element-257">
                Mi éxito no fue casualidad
              </p>
            </div>
            <p className="text-[18px] md:text-[22px] font-inter text-center text-textDark leading-relaxed mb-4" data-id="element-258">
              Fue método, disciplina y la decisión de no rendirme.
            </p>
            <p className="text-[16px] md:text-[18px] font-inter text-center text-textDark leading-relaxed" data-id="element-259">
              Y ahora comparto ese mismo método contigo.
            </p>
          </div>
        </div>
        <div className="space-y-6 mb-10" data-id="element-260">
          <p className="text-[22px] md:text-[28px] font-bold font-poppins text-white text-center uppercase tracking-wide" data-id="element-261">
            Lo que dicen quienes ya están aprendiendo:
          </p>
          {testimonials.map((testimonial, index) => <div key={index} className="bg-lightBg p-8 rounded-2xl border-2 border-lightBorder shadow-lg" data-id="element-262">
              <div className="flex gap-1.5 mb-4" data-id="element-263">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-primary text-primary" data-id="element-264" />)}
              </div>
              <p className="text-[16px] md:text-[18px] font-inter text-textDark italic mb-3 leading-relaxed" data-id="element-265">
                "{testimonial.text}"
              </p>
              <p className="text-[15px] md:text-[17px] font-bold font-inter text-primary" data-id="element-266">
                — {testimonial.name}
              </p>
            </div>)}
        </div>
        <div className="text-center space-y-6 relative" data-id="element-267">
          <p className="text-[18px] md:text-[22px] font-bold font-inter text-white leading-relaxed" data-id="element-268">
            Personas reales están transformando sus vidas cada día.
          </p>
          <p className="text-[24px] md:text-[32px] font-bold font-poppins text-primary tracking-tight uppercase" data-id="element-269">
            ¿Estás listo para ser el siguiente?
          </p>
          <div className="pt-4 relative" data-id="element-270">
            <div className="absolute inset-0 bg-primary/20 blur-2xl rounded-full animate-pulse" data-id="element-271"></div>
            <a href="https://closerdigital.net/F/NLeon1" target="_blank" rel="noopener noreferrer" onClick={handleCTAClick} className="group relative inline-flex items-center justify-center gap-3 px-8 py-4 md:px-10 md:py-5 bg-gradient-to-r from-primary via-primary to-primaryHover text-white text-[17px] md:text-[20px] font-bold font-poppins rounded-full shadow-2xl hover:shadow-primary/80 transition-all duration-300 transform hover:scale-110 w-full md:w-auto uppercase tracking-wide animate-pulse hover:animate-none overflow-hidden max-w-xl mx-auto" data-id="element-272">
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent animate-shimmer" data-id="element-273"></div>
              <BriefcaseIcon className="w-6 h-6 group-hover:scale-125 transition-transform duration-300 relative z-10" data-id="element-274" />
              <span className="relative z-10" data-id="element-275">
                Ver Casos Reales y Resultados
              </span>
              <ArrowRightIcon className="w-6 h-6 group-hover:translate-x-2 transition-transform duration-300 relative z-10" data-id="element-276" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}